/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestmentEntityNews} from '../api'

 export const useQueryGetInvestmentEntityNews = createReactQueryHook('getInvestmentEntityNews', getInvestmentEntityNews)
